/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * OrganizationType defines possible types of organization.   - ORGANIZATION_TYPE_DEFAULT: default organization type
 * @export
 * @enum {string}
 */

export const CastaiUsersV1beta1OrganizationType = {
    DEFAULT: 'ORGANIZATION_TYPE_DEFAULT',
    ENTERPRISE: 'ORGANIZATION_TYPE_ENTERPRISE',
    CHILD: 'ORGANIZATION_TYPE_CHILD'
} as const;

export type CastaiUsersV1beta1OrganizationType = typeof CastaiUsersV1beta1OrganizationType[keyof typeof CastaiUsersV1beta1OrganizationType];



